import { IconProps } from ".";

export const InfoCircleIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00004 0.333344C3.31814 0.333344 0.333374 3.31811 0.333374 7.00001C0.333374 10.6819 3.31814 13.6667 7.00004 13.6667C10.6819 13.6667 13.6667 10.6819 13.6667 7.00001C13.6667 3.31811 10.6819 0.333344 7.00004 0.333344ZM5.66671 6.33334C5.66671 5.96515 5.96518 5.66668 6.33337 5.66668H7.00004C7.36823 5.66668 7.66671 5.96515 7.66671 6.33334V9.66668C7.66671 10.0349 7.36823 10.3333 7.00004 10.3333C6.63185 10.3333 6.33337 10.0349 6.33337 9.66668V7.00001C5.96518 7.00001 5.66671 6.70153 5.66671 6.33334ZM6.33337 4.33334C6.33337 4.70153 6.63185 5.00001 7.00004 5.00001C7.36823 5.00001 7.66671 4.70153 7.66671 4.33334C7.66671 3.96515 7.36823 3.66668 7.00004 3.66668C6.63185 3.66668 6.33337 3.96515 6.33337 4.33334Z"
        fill="currentColor"
        style={{ fill: "currentColor", fillOpacity: 1 }}
      />
    </svg>
  );
};
